import client from "./client";

const emptyBlock = () => ({
  type: "paragraph",
  level: 2,
  style: "bullet",
  language: "",
  image: "",
  code: "",
  text: "",
  items: "",
  cite: "",
  caption: "",
  title: "",
});

export const emptyArticle = {
  slug: "",
  title: "",
  excerpt: "",
  categorySlug: "",
  categoryLabel: "",
  publishedAt: "",
  readMinutes: 5,
  authorName: "",
  authorRole: "",
  authorAvatar: "",
  cover: "",
  coverAlt: "",
  featured: false,
  tags: "",
  body: [emptyBlock()],
};

const blockCard = (block = {}) => ({
  type: block.type || "paragraph",
  level: Number(block.level) === 3 ? 3 : 2,
  style: block.style === "number" ? "number" : "bullet",
  language: block.language || "",
  image: block.image || "",
  code: block.code || "",
  text: block.text || "",
  items: block.items || "",
  cite: block.cite || "",
  caption: block.caption || "",
  title: block.title || "",
});

export function prepareArticle(form = {}) {
  return {
    slug: form.slug || "",
    title: form.title || "",
    excerpt: form.excerpt || "",
    categorySlug: form.categorySlug || "",
    categoryLabel: form.categoryLabel || "",
    publishedAt: form.publishedAt || "",
    readMinutes: Number(form.readMinutes) || 1,
    authorName: form.authorName || "",
    authorRole: form.authorRole || "",
    authorAvatar: form.authorAvatar || "",
    cover: form.cover || "",
    coverAlt: form.coverAlt || "",
    featured: !!form.featured,
    tags: form.tags || "",
    body: (form.body || []).map(blockCard),
  };
}

export const listArticles = (page = 1, limit = 100) =>
  client.post("/article/list", { page, limit });
export const getArticle = (id) => client.post("/article/get", { id });
export const addArticle = (payload) => client.post("/article/add", payload);
export const updateArticle = (payload) => client.post("/article/update", payload);
export const deleteArticle = (id) => client.post("/article/delete", { id });
export { emptyBlock };
